<template>
  <vz-switcher
    :modelValue="orderType"
    class="vz-personal-order-switcher"
    :items="orderTypesItems"
    tabs
    @update:modelValue="setOrderType"
  />
</template>

<script setup lang="ts">
import VzSwitcher from '~/components/ui-kit/vz-switcher.vue';
import {orderTypes} from '~/common/objects';
import {useOrderStore} from '~/stores/order';
import {storeToRefs} from 'pinia';
import {useUserStore} from '~/stores/personal/user';
import $breakpoints from '@/composables/breakpoints'
import {isDevServer} from '~/composables/useVzFetch';

const { orderType } = storeToRefs(useOrderStore())
const { setOrderType } = useOrderStore()
const {isAuth} = storeToRefs(useUserStore())

const isNewOrder = computed(() => {
  return !useRoute().params.guid
})

const orderTypesItems = computed(() => {
  // let hasMulti = isDevServer // todo: true
  let hasMulti = true

  if (!isAuth.value || !isNewOrder.value || $breakpoints?.width <= 1024 ) {
    hasMulti = false
  }

  return hasMulti
    ? orderTypes
    : orderTypes.filter(item => item.value !== 'multi')
})
</script>
